/**
 * Finding fingerprint — identifies "the same finding" across runs of the same
 * project. LLM output text varies run to run, so we anchor on the stable
 * parts: check id + normalized check_point + day number. Consistency rules
 * use the rule id, which is fully stable.
 *
 * Client-safe (pure string ops). The server store and the browser compute
 * identical fingerprints so inline feedback buttons can match their action.
 */

import type { FindingSource } from "./types";

export function normalizeForFingerprint(text: string): string {
  return text
    .toLowerCase()
    .replace(/[\s　]+/g, "")
    .replace(/[、。,.:;：；・()（）[\]「」『』"'`~!?！？]/g, "");
}

export function findingFingerprint(p: {
  source: FindingSource;
  checkId: string;
  checkPoint: string;
  dayNumber: number | null;
}): string {
  return [
    p.source,
    p.checkId,
    normalizeForFingerprint(p.checkPoint),
    p.dayNumber ?? "",
  ].join("|");
}
